import { faArrowsRotate } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  FormControlLabel,
  FormGroup,
  Stack,
  Switch
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useMemo } from 'react';

import InternalTicketsTables from '@/features/InternalTicketsTables';

import { refetchInternalTicketsAtom } from '../Dashboard/Dashboard.store';
import useStyles from './InternalTickets.style';

const InternalTickets = () => {
  const { classes } = useStyles();
  const queryClient = useQueryClient();
  const [refetchInternalTickets, setRefetchInternalTickets] = useAtom<boolean>(
    refetchInternalTicketsAtom
  );

  const refetch = useMemo(() => {
    return () => {
      queryClient.invalidateQueries({
        queryKey: ['v2/tickets/search']
      });
    };
  }, [queryClient]);

  return (
    <div className={classes.pageContainer}>
      <Stack direction="row" spacing={2} className={classes.refreshButton}>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={refetchInternalTickets}
                onChange={() =>
                  setRefetchInternalTickets((prev: boolean) => !prev)
                }
              />
            }
            label="Auto Refresh"
          />
        </FormGroup>
        <Button
          onClick={() => refetch()}
          variant="contained"
          color="primary"
          startIcon={<FontAwesomeIcon icon={faArrowsRotate} />}
        >
          Refresh Tickets
        </Button>
      </Stack>
      <InternalTicketsTables />
    </div>
  );
};

export default InternalTickets;
